import React, { createContext, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { LANG_STORAGE_KEY } from '../constants/mvp';

interface LanguageContextType {
  currentLang: string;
  toggleLanguage: () => void;
  changeLanguage: (lng: string) => void;
}

const LanguageContext = createContext<LanguageContextType | undefined>(undefined);

export const LanguageProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { i18n } = useTranslation();

  const persistLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
    if (typeof window !== 'undefined') {
      localStorage.setItem(LANG_STORAGE_KEY, lng);
    }
  };

  const changeLanguage = (lng: string) => {
    persistLanguage(lng);
  };

  const toggleLanguage = () => {
    persistLanguage(i18n.language === 'zh' ? 'en' : 'zh');
  };

  return (
    <LanguageContext.Provider
      value={{
        currentLang: i18n.language,
        toggleLanguage,
        changeLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return ctx;
};
